if (!customElements.get('aura-photo-product')) {
  customElements.define('aura-photo-product', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const initialFileHint = this.querySelector('[data-file-status]').textContent;
      this.addEventListener('change', (event) => {
        const input = event.target;
        if (input.matches('[data-toggle]')) {
          const panel = this.querySelector(`[data-panel="${input.dataset.toggle}"]`);
          if (!panel) return;
          panel.hidden = !input.checked;
          panel.querySelectorAll('input,textarea,select').forEach(control => {
            control.disabled = !input.checked;
            control.required = input.checked && control.hasAttribute('data-required');
            if (!input.checked) control.value = '';
          });
        }
        if (input.matches('[data-photo-input]')) {
          if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
          const file = input.files[0];
          const preview = this.querySelector('[data-photo-preview]');
          preview.hidden = true;
          this.querySelector('[data-file-status]').textContent = initialFileHint;
          if (file) {
            this.querySelector('[data-file-status]').textContent = file.name;
            this.previewUrl = URL.createObjectURL(file);
            preview.src = this.previewUrl;
            preview.hidden = false;
          }
        }
        if (input.matches('[data-variant]')) {
          const option = input.selectedOptions[0];
          const available = option.dataset.available === 'true' && Number(option.dataset.price) > 0;
          const submit = this.querySelector('[data-submit]');
          submit.disabled = !available;
          submit.textContent = available ? submit.dataset.label : submit.dataset.unavailable;
          this.querySelector('[data-price]').textContent = option.dataset.formatted;
          this.querySelector('[data-availability]').textContent = available ? this.dataset.availableLabel : submit.dataset.unavailable;
          this.querySelector('.ap-sticky>div>span').textContent = option.dataset.formatted;
        }
      }, {signal});
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-slide]');
        if (!thumb || !this.contains(thumb)) return;
        event.preventDefault();
        const slide = this.querySelectorAll('.ap-slide')[Number(thumb.dataset.slide)];
        slide.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'nearest',inline:'start'});
      }, {signal});
      const track = this.querySelector('.ap-gallery-track');
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio < .6) return;
          const index = [...track.children].indexOf(entry.target);
          this.querySelectorAll('[data-slide]').forEach(link => {
            if (Number(link.dataset.slide) === index) link.setAttribute('aria-current','true');
            else link.removeAttribute('aria-current');
          });
        });
      }, {root:track,threshold:.6});
      track.querySelectorAll('.ap-slide').forEach(slide => this.observer.observe(slide));
      this.querySelector('[data-product-form]').addEventListener('submit', event => {
        if (this.querySelector('[data-submit]').disabled) event.preventDefault();
      }, {signal});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    }
  });
}
